"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (duration, durationUnit, ranges) {
    var relatedBlock = ranges.find(function (r) {
        return r.unit === durationUnit;
    });

    if (!relatedBlock) {
        return false;
    }

    return duration <= relatedBlock.max && duration >= relatedBlock.min;
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/duration/isDurationWithinRange.js
// module id = 92
// module chunks = 0